import { handleResponse } from './apiService';
import { wait } from './utilsService';
import config from '../config/config.json';

const RATE_LIMIT_ERROR = 'Max rate limit reached';
const RETRY_DELAY = 2000;
const bscanUrlExt = config.bscUrlExt;

const processResults = async (url) => {
  const _result = await fetch(url).then(handleResponse);
  const { result } = _result;
  const hasReachedLimit = result === RATE_LIMIT_ERROR;
  if (hasReachedLimit) return Promise.reject(RATE_LIMIT_ERROR);
  return Promise.resolve(_result);
};

export const getUserTxs = async (account, scanUrl, _config = {}) => {
  const apikey = process.env.REACT_APP_SCANNER_API_KEY;
  const baseConfig = { page: 1, offset: 50 };
  const mergedConfig = { ...baseConfig, ..._config };

  const config = {
    address: account,
    apikey,
    module: 'account',
    action: 'txlist',
    sort: 'desc',
    ...mergedConfig,
  };
  const _url = `${scanUrl}api`.replaceAll('https://', bscanUrlExt);
  const searchParams = new URLSearchParams({ ...config });

  return new Promise(async (resolve, reject) => {
    try {
      const url = `${_url}?${searchParams}`;
      const result = await processResults(url);
      return resolve(result);
    } catch (error) {
      if (error === RATE_LIMIT_ERROR) {
        await wait(RETRY_DELAY);
        return getUserTxs(account, scanUrl, _config);
      }
      return reject(error);
    }
  });
};

export const getTokenPriceByAddress = async (address) => {
  const url = `https://api.pancakeswap.info/api/v2/tokens/${address}`;
  const res = await fetch(url).then(handleResponse);
  return res;
};
